import { Entity } from '../../core/commons/entity';

export class ReportErrorMessage implements Entity{

    public id: number = null;
    
    private emisor: String;

    private receptor: String;

    private subject: String;

    private body: String;

    private solucionado: Boolean;

    private image: String;

    
    constructor(value: Object) {
        Object.assign(this, value);
    };
    
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/report-error-message.ts